export const CREATE_JOB_OPENING_INITIAL_VALUES = {
    title: "",
    department: "",
    hiringManager: "",
    assignedRecruiter: "",
    numberOfPosition: "",
    targetDate: "",
    dateOpened: "",
    jobOpeningStatus: "",
    jobType: "",
    industry: "",
    workExperience: "",
    salary: "",
    requiredSkills: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    description: "",
    requirements: "",
    benefits: "",
    jobSummaryAttachment: "",
    attachments: "",
};
